export interface MobilePaymentPayload {
    country_code: string
    client_code: string
    provider: string
    amount: number
    success_url: string
    error_url: string
    phone_number?: string
}

export interface MobilePaymentResponse {
    transaction_id?: string
    redirect_url?: string
    uuid?: string
}

export interface MobilePaymentState {
    loading?: boolean
    response?: MobilePaymentResponse
    error?: string
    uuid?: string
    status?: string
}

export const MobilePaymentSliceEnum = {
    MOBILE_PAYMENT: 'mobilePayment',
    MOBILE_PAYMENT_ACTION: 'mobilePaymentAction',
    CHECK_PAYMENT_CONFIRMATION: 'checkPaymentConfirmation'
}
